import { colorNameFormatter } from '@/components/uikit/lib';
import { app } from '@/main';

/**
 * Show notify (Using "quasar notify")
 * @param message {string} - Notify message
 * @param color {string} - Notify color [primary|secondary|accent|dark|success|danger|info|warning]
 * @param position {string} - Position of Notify
 */
const showNotify = ({ message, color, position }) => {
  app.$q.notify({
    message: message,
    color: colorNameFormatter(color),
    position: position,
    group: false,
    timeout: 2000,
  });
};

/**
 * Return method type
 * 決められたメソッド以外では "default" を返す。
 * @param type {string} - Method type
 * @returns {string}
 */
export const methodType = type => {
  if (
    type !== 'create' &&
    type !== 'save' &&
    type !== 'change' &&
    type !== 'update' &&
    type !== 'delete' &&
    type !== 'fetch' &&
    type !== 'register' &&
    type !== 'add' &&
    type !== 'export' &&
    type !== 'access'
  ) {
    return 'default';
  } else {
    return type;
  }
};

const notify = {
  custom(options = { type: '', message: '', position: '' }) {
    const type = options.type ? options.type : 'primary';
    const message = options.message ? options.message : '';
    const position = options.position ? options.position : 'top';

    showNotify({
      message: message,
      color: colorNameFormatter(type),
      position: position,
    });

    return Promise.resolve();
  },
  success(method, name) {
    const messageType = name => {
      if (!name) return 'success_simple';
      return 'success';
    };

    showNotify({
      message: app.$t(`${methodType(method)}.${messageType(name)}`, { name: name }),
      color: colorNameFormatter('success'),
      position: 'top',
    });

    return Promise.resolve();
  },
  error(method, name) {
    const messageType = name => {
      if (!name) return 'error_simple';
      return 'error';
    };

    showNotify({
      message: app.$t(`${methodType(method)}.${messageType(name)}`, { name: name }),
      color: colorNameFormatter('danger'),
      position: 'top',
    });

    return Promise.resolve();
  },
};

export default notify;
